import { computed } from "vue";
import { ref } from "vue";

/*
 * Validates and formats a time duration (HHH:mm or HHH) to HHH:mm.
 * Returns an empty string if the input is invalid.
 */
function formatDurationInput(input) {
    let trimmedInput = String(input || '').trim();
    if (!trimmedInput)
      return "";
    
    if(trimmedInput.startsWith('.') | trimmedInput.startsWith(':'))
      trimmedInput = '0' + trimmedInput;

    let fullDotDurationRegex = /^(\d+).([0-5][0-9])$/;
    let fullColonDurationRegex = /^(\d+):([0-5][0-9])$/;
    let hourOnlyRegex = /^(\d+)$/;

    if (fullDotDurationRegex.test(trimmedInput))
      trimmedInput = trimmedInput.replace('.', ':');

    if (fullColonDurationRegex.test(trimmedInput))
      return trimmedInput;

    let hourMatch = trimmedInput.match(hourOnlyRegex);
    if (hourMatch)
      return `${hourMatch[0]}:00`;

    return "";
}

export function useDurationFormatter(initialValue = '') {
    let initialFormatted = formatDurationInput(initialValue);
    
    let inputValue = ref(initialFormatted);
    let finalValue = ref(initialFormatted);

    let totalMinutes = computed(() => {
      if (!finalValue.value)
        return null;

      let [hours, minutes] = finalValue.value.split(':').map(Number);
      
      return ((hours * 60) + minutes) > 0 ? ((hours * 60) + minutes) : null;
    });

    let applyFormat = () => {
      let validated = formatDurationInput(inputValue.value);
      
      inputValue.value = validated ? String(validated).padStart(5, '0') : validated; 
      finalValue.value = validated ? String(validated).padStart(5, '0') : validated;
    };

    let takeMinuteValue = (totalMinutes) => {
      if (totalMinutes == null)
        return;
      
      let hours = Math.floor(totalMinutes / 60);
      let minutes = totalMinutes % 60;

      inputValue.value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      
      applyFormat();
    }

    let emptyValue = () => {
      inputValue.value = '';
      finalValue.value = '';
    }

    return {
      inputValue,
      finalValue,
      totalMinutes,
      applyFormat,
      takeMinuteValue,
      emptyValue
    };
}